import { Resource as i, API as a } from "@coveo/platform-client";
const t = class t extends i {
  /**
   * Retrieves all entitlement quotas for the specified organization. This endpoint provides a comprehensive view of all entitlements and their associated quota information.
   */
  listEntitlementQuotas() {
    return this.api.get(t.baseUrl);
  }
  /**
   * Retrieves quota information for a specific entitlement key within the organization. Returns detailed quota status including current usage for the specified entitlement.
   */
  async getEntitlementQuota(e) {
    return this.api.get(`${t.baseUrl}/${e}`);
  }
  /**
   * Retrieves products associated with a specific entitlement within the organization.
   */
  async getEntitlementProducts(e) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${e}/related-products`)
    );
  }
  /**
   * Retrieves historical quota usage data for a specific entitlement within a specified time range. Returns detailed usage statistics and quota information over the requested period.
   */
  async getEntitlementHistory(e, s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${e}/history`, s)
    );
  }
  /**
   * Exports historical quota usage data for a specific entitlement within a specified time range as a CSV file. Enables download of detailed usage statistics and quota information for external analysis and reporting.
   */
  async exportEntitlementHistory(e, s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${e}/history/export`, s),
      { responseBodyFormat: "text" }
    );
  }
};
t.baseUrl = `/api/private/organizations/${a.orgPlaceholder}/quotas/entitlements`;
let r = t;
export {
  r as OrganizationQuotasResource
};
//# sourceMappingURL=OrganizationQuotasResource.js.map
